import sideBarDefaultLogoDarkMode from "@assets/images/sidebar-deafult-logo-darkMode.png";
import sideBarDefaultLogo from "@assets/images/sidebar-default-logo.png";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Avatar, Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo = theme === "defaultLight" ? sideBarDefaultLogo : sideBarDefaultLogoDarkMode;

  return (
   <Box
  display="flex"
  paddingY={2}
  paddingX={4}
  alignItems="center"
>
  <Box
    width={8}
    height={8}
    borderRadius="50%"
    overflow="hidden"
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <img
      src={logo}
      alt="Sidebar Logo"
      style={{
        width: "50%",
        height: "auto",
        display: "block",
      }}
    />
  </Box>

  <Text size={3} fontWeight="bold">
    TireKart Dashboard
  </Text>
</Box>

  );
};
